export function removeCSSClass(ele, cls) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
}

export function addCSSClass(ele, cls) {
  ele.classList.add(cls);
}

export const toAbsoluteUrl = pathname => {
  const publicUrl = (typeof process !== "undefined" && process.env && process.env.PUBLIC_URL) || "";
  // Check if publicUrl is '.' and ensure we return a proper relative path like ./path
  const base = publicUrl === "." ? "./" : publicUrl;
  
  if (pathname.startsWith("/")) {
    return base + pathname.slice(1);
  }
  return base + pathname;
};
